module.exports = __webpack_public_path__ + "img/shipo-menu-settings-white.1c56bb28.svg";